function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref = /*#__PURE__*/React.createElement("title", null, "Vector");

var _ref2 = /*#__PURE__*/React.createElement("desc", null, "Created using Figma");

var _ref3 = /*#__PURE__*/React.createElement("g", {
  id: "Canvas",
  transform: "translate(24600 -16313)"
}, /*#__PURE__*/React.createElement("g", {
  id: "Vector"
}, /*#__PURE__*/React.createElement("use", {
  xlinkHref: "#path0_stroke",
  transform: "matrix(8.01574e-16 -1 1 1.03516e-15 -24598.8 16319.2)"
})));

var _ref4 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
  id: "path0_stroke",
  d: "M 0 5.69451L -0.359736 5.34725L -0.694954 5.69451L -0.359736 6.04177L 0 5.69451ZM 5.13729 -0.347261L -0.359736 5.34725L 0.359736 6.04177L 5.85677 0.347261L 5.13729 -0.347261ZM -0.359736 6.04177L 5.13729 11.7363L 5.85677 11.0418L 0.359736 5.34725L -0.359736 6.04177Z"
}));

var SvgCarrot = function SvgCarrot(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 13,
    height: 7,
    viewBox: "0 0 13 7"
  }, props), _ref, _ref2, _ref3, _ref4);
};

export default __webpack_public_path__ + "static/media/Carrot.4852cf37.svg";
export { SvgCarrot as ReactComponent };